export const PERISCOPE_FILTER_PLACEHOLDER = {
	FILTER_BY_ACCESS: 'Filter by Access',
	FILTER_BY_MODIFIED_BY: 'Filter by Modified By'
};
